module.exports = __webpack_public_path__ + "img/legnanocitta.2a82000b.png";